import React from 'react';
import { Box, Typography } from '@mui/material';
import { SalesOrderAsyncAutocomplete } from 'ui/components/Autocomplete/SalesOrderAsyncAutocomplete';
import { SalesOrder } from 'services/salesOrders';
import FBOButton from 'ui/theme/components/FBOButton/FBOButton';

const DRAWER_WIDTH = 280;

interface SalesOrderSelectSidebarProps {
  selectedSalesOrder: SalesOrder | null;
  setSelectedSalesOrder: (salesOrder: SalesOrder | null) => void;
  onExportPDF: () => void;
}

const SalesOrderSelectSidebar = ({
  selectedSalesOrder,
  setSelectedSalesOrder,
  onExportPDF,
}: SalesOrderSelectSidebarProps) => {
  return (
    <Box
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        borderRight: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        height: '100%',
        overflow: 'auto',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Sales Order Selection
        </Typography>
      </Box>
      <Box sx={{ mt: 2, px: 2 }}>
        <SalesOrderAsyncAutocomplete
          label="Sales Order Number"
          value={selectedSalesOrder?.id ?? null}
          onChange={setSelectedSalesOrder}
          placeholder="Select Sales Order"
          dataQa="sales-order-report-number-field"
          customQuickSearchColumns={['number']}
          expands={['location', 'carrier', 'salesOrderItems']}
        />
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <FBOButton
            icon="download"
            variant="primary"
            color="positive"
            onClick={onExportPDF}
            data-qa="export-pdf-button"
            aria-label="Download sales-order PDF"
            disabled={!selectedSalesOrder}
          >
            Download PDF
          </FBOButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SalesOrderSelectSidebar;
